import { Box, SxProps } from "@mui/material";
import { useAppSelector } from "../../../../Redux/hooks";
import Finalize from "./Finalize";
import ConsentBlock from "./ConsentBlock";
import "../../../QuestionBuilder/QuestionPreview/questionpreview.scss";

const consentWrapper: SxProps = {
  width: { md: "60%", xs: "100%" },
  bgcolor: "#FFFFFF",
  margin: "0 auto",
  p: { md: 4, xs: 2 },
  borderRadius: { md: "12px", xs: 0 },
  my: 2,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  backgroundColor: "#fff",
  boxShadow: { md: "0px 0px 12px 0px #00000014", xs: "none" },
};

const ConsentListStyle: SxProps = {
  flex: "1",
  height: "100%",
  p: { md: 1, xs: 0 },
  overflowY: "auto",
};

const ConsentBlockWrapper = () => {
  const blocks = useAppSelector((state) => state.providerConsent.blocks);
  return (
    <Box sx={ConsentListStyle}>
      <Box sx={consentWrapper}>
        {blocks.length > 0
          ? blocks.map((block, index) => {
              return (
                <ConsentBlock block={block} index={index} key={block.id} />
              );
            })
          : null}
        <Finalize />
      </Box>
    </Box>
  );
};

export default ConsentBlockWrapper;
